// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal[data-v-5a6e1ac4]{box-shadow:0 1px 1px rgba(0,0,0,.08),0 2px 2px rgba(0,0,0,.08),0 4px 4px rgba(0,0,0,.08),0 6px 8px rgba(0,0,0,.08),0 8px 16px rgba(0,0,0,.08);overflow:hidden;text-align:left}.modal>div[data-v-5a6e1ac4]{padding:0 .75rem .75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
